import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import { TranslationSchema } from "../../../models/translations";
import { TranslationService } from "../../../services/translation.service";

@Pipe({
    name: 'timeSpent',
    standalone: false
})
export class TimeSpentPipe implements PipeTransform {

  constructor(private translationService: TranslationService) { }

  transform(value: string): string {
    const date = moment(value);
    const currentDate = moment();

    const diff = moment.duration(currentDate.diff(date));

    const yearDiff = diff.get('years');
    const monthDiff = diff.get('months');
    const dateDiff = diff.get('days');

    let dateParts = new Array<string>();

    if (yearDiff > 0) {
      const translationInstant: (schema: any) => any =
        yearDiff > 1
          ? x => x.Screens.Patients.InfoWidget.TimeSpent.Years
          : x => x.Screens.Patients.InfoWidget.TimeSpent.Year
      dateParts.push(`${yearDiff} ${this.translationService.translate(translationInstant)}`);
    }

    if (monthDiff > 0) {
      const translationInstant: (schema: any) => any =
        monthDiff > 1
          ? x => x.Screens.Patients.InfoWidget.TimeSpent.Months
          : x => x.Screens.Patients.InfoWidget.TimeSpent.Month
      dateParts.push(`${monthDiff} ${this.translationService.translate(translationInstant)}`);
    }

    if ((yearDiff == 0) && (monthDiff == 0)) {
      if (dateDiff == 0) {
        dateParts.push(this.translationService.translate(x => x.Screens.Patients.InfoWidget.TimeSpent.Today));
      }
      else {
        const translationInstant: (schema: any) => any =
          dateDiff > 1
            ? x => x.Screens.Patients.InfoWidget.TimeSpent.Days
            : x => x.Screens.Patients.InfoWidget.TimeSpent.Day
        dateParts.push(`${dateDiff} ${this.translationService.translate(translationInstant)}`);
      }
    }

    return dateParts.join(' ');
  }
}